import { createContext } from 'react';

export const TaskSelectedContext = createContext(null);
